/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LlmCriteriaEvaluation } from './llmCriteriaEvaluation';

/**
 * Checklist of specific criteria met/unmet for this dimension.
 */
export type EvalDimRatingCriteriaEvaluations = LlmCriteriaEvaluation[] | null;
